<template>
  <path d="M4 5L0.535898 0.5H7.4641L4 5Z" fill="currentColor" />
</template>
